import { render } from "./timetable.vue?vue&type=template&id=dab19908"
import script from "./timetable.vue?vue&type=script&lang=js"
export * from "./timetable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__